"use client";

import { useLocalStorage } from "usehooks-ts";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { APP_NAME_GENERIC, DESO_APP_NAME } from "@/utils/constants";

const HEADING = `Welcome to ${APP_NAME_GENERIC}`;

const WelcomeFocusDialog = () => {
  const [showWelcomeFocusDialog, setShowWelcomeFocusDialog] = useLocalStorage(
    "showWelcomeFocusDialog",
    true,
  );

  return (
    <Dialog
      open={showWelcomeFocusDialog}
      onOpenChange={setShowWelcomeFocusDialog}
    >
      <DialogContent
        className="
          w-[90%] max-w-[740px]
          md:h-auto md:w-full
        "
      >
        <DialogTitle
          className="
            mt-7 border-b-0 py-3 text-center text-xl font-semibold
            text-muted-foreground
          "
        >
          {HEADING}
        </DialogTitle>
        <DialogDescription
          className="
            pt-0 text-center text-sm/6 text-foreground
            md:px-16
          "
        >
          {APP_NAME_GENERIC} is the first decentralized social network, built on{" "}
          {DESO_APP_NAME}, where you can earn without limits, take ownership of
          your social graph, and trade any asset permissionlessly.
        </DialogDescription>
        <div
          className="
            flex flex-col gap-4 p-6 pt-0 text-center
            md:gap-4
          "
        >
          <div
            className="
            relative aspect-video w-full overflow-hidden rounded-md
          "
          >
            <iframe
              width="560"
              height="315"
              className="absolute inset-0 size-full border-0"
              src="https://www.youtube.com/embed/kPPb_S5Ry5E"
              title={`${APP_NAME_GENERIC} Introduction`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>

          <div
            className="
              flex items-center justify-center
              md:mt-2
            "
          >
            <Button
              onClick={() => {
                setShowWelcomeFocusDialog(false);
              }}
              className="w-fit text-center"
            >
              Continue
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeFocusDialog;
